import React from 'react';
import { Link } from 'react-router-dom';
import './Kaeden.css';
import PageHero from './PageHero';

const Kaeden = () => {
  const skillsData = [
    {
      name: "Social Media Marketing",
      description: "Strategic content planning and audience engagement",
      icon: "/ig.svg",
      rating: 90
    },
    {
      name: "Content Creation",
      description: "Creative video and image content development",
      icon: "/yt.svg",
      rating: 85
    },
    {
      name: "Video Editing",
      description: "Professional video production and post-production",
      icon: "/davinci.png",
      rating: 80
    },
    // {
    //   name: "Audio Editing",
    //   description: "Sound design and audio post-production",
    //   icon: "/nodejs.svg",
    //   rating: 75
    // },
    // {
    //   name: "Visual Effects",
    //   description: "Motion graphics and special effects",
    //   icon: "/mongodb.svg",
    //   rating: 70
    // },
    // {
    //   name: "Brand Strategy",
    //   description: "Campaign planning and brand promotion",
    //   icon: "/java.svg",
    //   rating: 85
    // }
  ];

  const projectsData = [
    {
      title: "FTC Team Timeline Video",
      client: "Local FTC Robotics Team",
      year: "2024",
      description: "Created a comprehensive timeline video showcasing the team's progress, achievements, and journey throughout the competition season. The video highlighted key milestones and team accomplishments.",
      skills: ["Video Editing", "Video Production", "Social Media Marketing", "Content Creation"],
      tech: ["/davinci.png", "/ig.svg", "/yt.svg"],
      videoSrc: "/timeline.mp4"
    },
    // {
    //   title: "Social Media Campaign",
    //   client: "Local Business Partnership",
    //   year: "2024",
    //   description: "Developed and executed a multi-platform social media marketing campaign that increased engagement by 150% and drove significant traffic to client websites.",
    //   skills: ["Content Strategy", "Multi-Platform Management", "Analytics", "Community Engagement"],
    //   tech: ["/ig.svg", "/yt.svg", "/react.svg"],
    //   videoSrc: "/media.mp4"
    // }
  ];

  return (
    <>
      <PageHero
        eyebrow="Crew / Kaeden Martinez"
        title="Kaeden Martinez"
        lede="Social media marketing and content creation. I help brands connect with their audience through content that gets watched, not scrolled past."
        meta={['2+ years experience', '15+ projects', 'Strategy · Content · Edit']}
      >
        <Link to="/contact?reason=contact" className="btn btn--primary">
          Work with me <span className="btn-arrow">→</span>
        </Link>
        <Link to="/crew" className="btn btn--ghost">
          Back to crew
        </Link>
      </PageHero>

      <main className="kaeden-main-content" id="main">
        <section className="section kaeden-about-section">
          <div className="container">
            <p className="eyebrow">About</p>
            <div className="kaeden-about-content">
              <p className="kaeden-about-text reveal reveal-up">
                I'm Kaeden Martinez, an 11th-grade student specializing in social media
                marketing and content creation. With an eye for what's actually working
                on each platform, I help brands reach their audiences through content and
                campaigns built on strategy rather than guesswork.
              </p>

              <dl className="kaeden-about-highlights" data-stagger="0.07">
                <div className="kaeden-highlight-item reveal reveal-up">
                  <dt className="kaeden-highlight-number">2+</dt>
                  <dd className="kaeden-highlight-text">Years experience</dd>
                </div>
                <div className="kaeden-highlight-item reveal reveal-up">
                  <dt className="kaeden-highlight-number">15+</dt>
                  <dd className="kaeden-highlight-text">Projects completed</dd>
                </div>
                <div className="kaeden-highlight-item reveal reveal-up">
                  <dt className="kaeden-highlight-number">100%</dt>
                  <dd className="kaeden-highlight-text">Dedication to quality</dd>
                </div>
              </dl>
            </div>
          </div>
        </section>

        <section className="section section--alt kaeden-skills-section">
          <div className="container">
            <div className="section-head">
              <p className="eyebrow">Toolkit</p>
              <h2 className="section-title reveal reveal-up">My skills.</h2>
              <p className="section-lede reveal reveal-up" style={{ '--reveal-delay': '0.08s' }}>
                Digital marketing and content creation, judged against real projects.
              </p>
            </div>

            <ul className="kaeden-skills-grid" data-stagger="0.06">
              {skillsData.map((skill) => (
                <li className="kaeden-skill-card reveal reveal-up" key={skill.name}>
                  <div className="kaeden-skill-header">
                    <img src={skill.icon} alt="" className="kaeden-skill-icon" />
                    <div className="kaeden-skill-info">
                      <h3 className="kaeden-skill-name">{skill.name}</h3>
                      <p className="kaeden-skill-description">{skill.description}</p>
                    </div>
                    <span className="kaeden-rating-text">{skill.rating}</span>
                  </div>
                  <div className="kaeden-skill-rating">
                    <span className="kaeden-rating-bar" style={{ width: `${skill.rating}%` }} />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="section kaeden-projects-section">
          <div className="container">
            <div className="section-head">
              <p className="eyebrow">Selected work</p>
              <h2 className="section-title reveal reveal-up">Featured work.</h2>
            </div>

            <div className="kaeden-projects-grid" data-stagger="0.07">
              {projectsData.map((project, index) => (
                <div className="kaeden-project-card reveal reveal-up" key={index}>
                  <div className="kaeden-video-col">
                    <div className="kaeden-video-container">
                      <video 
                        src={project.videoSrc}
                        title={project.title}
                        controls={true}
                        muted={false}
                        loop={true}
                        autoPlay={false}
                        preload="metadata"
                        className="kaeden-project-video"
                      >
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                  <div className="kaeden-project-info">
                    <div className="kaeden-project-timestamp">
                      {project.year} &middot; {project.client}
                    </div>
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                    <ul className="kaeden-project-skills">
                      {project.skills.map((skill) => (
                        <li key={skill}>{skill}</li>
                      ))}
                    </ul>
                    <div className="kaeden-tech-stack">
                      {project.tech.map((tech) => (
                        <img key={tech} src={tech} alt="" className="kaeden-tech-icon" />
                      ))}
                    </div>
                  </div>
                </div>
              ))}

              <div className="kaeden-project-card kaeden-more-to-come-card reveal reveal-fade">
                <div className="more-to-come">
                  <span className="more-to-come-mark" aria-hidden="true" />
                  <h3>More projects coming</h3>
                  <p>
                    I&rsquo;m constantly working on new campaigns and expanding the
                    portfolio — brand partnerships, collaborations, and creative work.
                  </p>
                  <div className="kaeden-coming-soon-features">
                    <span>Brand partnerships</span>
                    <span>Influencer collaborations</span>
                    <span>Creative campaigns</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section section--alt kaeden-contact-section">
          <div className="container">
            <div className="section-head">
              <p className="eyebrow">Say hello</p>
              <h2 className="section-title reveal reveal-up">Get in touch.</h2>
            </div>

            <div className="kaeden-contact-grid">
              <div className="kaeden-contact-card reveal reveal-up">
                <h3>Let&rsquo;s work together</h3>
                <p>Ready to make content that actually grows your brand?</p>
                <Link to="/contact?reason=contact" className="btn btn--primary">
                  Contact me <span className="btn-arrow">→</span>
                </Link>
              </div>

              <div
                className="kaeden-contact-info reveal reveal-up"
                style={{ '--reveal-delay': '0.08s' }}
              >
                <h3>Available for</h3>
                <ul>
                  <li>Social media marketing</li>
                  <li>Content creation</li>
                  <li>Video production</li>
                  <li>Audio editing</li>
                  <li>Visual effects</li>
                  <li>Brand strategy</li>
                </ul>
                <span className="kaeden-available-badge">
                  <span className="dot-live" aria-hidden="true" />
                  Available for new projects
                </span>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Kaeden; 